/** Human-friendly name for a profile, falling back to its email. */
export function displayNameOf(profile: { full_name: string; email: string }): string {
  const name = profile.full_name.trim();
  return name.length > 0 ? name : profile.email;
}
